import { RouterProvider } from 'react-router-dom';

import router, { maintenanceRouter } from './components/router/Router';
import { useAppMaintenanceStatus } from './hooks/use-app-maintenance-status';

export const AppRouter = () => {
    const { isMaintenanceActive } = useAppMaintenanceStatus();

    if (isMaintenanceActive) {
        return <RouterProvider router={maintenanceRouter} />;
    }

    return <RouterProvider router={router} />;
};
